// extracted by mini-css-extract-plugin
module.exports = {"timerNew":"styles_timerNew__3kY0L","timeLeft":"styles_timeLeft__1nkvw","vertical":"styles_vertical__3qXpQ","timer":"styles_timer__1adXt","mSec":"styles_mSec__3l4Zw"};